import type { AppointmentStatus as AppointmentStatusType } from "@/hooks/useAppointmentStatuses";

// Variants para badges baseados no tipo de status
const getStatusVariant = (
    statusName: string,
    finalType?: AppointmentStatusType["final_type"],
): "default" | "secondary" | "destructive" | "outline" => {
    if (finalType === "cancelado" || statusName === "cancelado") {
        return "destructive";
    }
    if (statusName === "entregue" || statusName === "pago") {
        return "outline";
    }
    if (finalType === "finalizado" || statusName === "finalizado") {
        return "outline";
    }
    if (statusName === "agendado") {
        return "secondary";
    }
    return "default";
};

// Helper para obter configuração de badge de status
export const getStatusBadgeConfig = (
    statusName: string,
    statuses?: AppointmentStatusType[]
): { label: string; variant: "default" | "secondary" | "destructive" | "outline" } => {
    const status = statuses?.find((s) => s.name === statusName);
    const label = status?.display_name || statusName;
    const variant = getStatusVariant(statusName, status?.final_type);

    return { label, variant };
};










